import { render, staticRenderFns } from "./ProgramPage.vue?vue&type=template&id=3f985450&scoped=true&"
import script from "./ProgramPage.vue?vue&type=script&lang=js&"
export * from "./ProgramPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f985450",
  null
  
)

export default component.exports